/* Caipi Redesign — Sorten-Landingpage: FAQ-Accordion + AJAX-Add (Cart-Drawer). */
(function () {
  'use strict';

  function initFaq(root) {
    var wrap = root.querySelector('[data-rd-var-faq]');
    if (!wrap || wrap.dataset.rdInit === '1') return;
    wrap.dataset.rdInit = '1';
    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.rd-var__faq-q');
      if (!btn) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      var ans = btn.parentNode.querySelector('.rd-var__faq-a');
      if (ans) { if (open) ans.setAttribute('hidden', ''); else ans.removeAttribute('hidden'); }
    });
  }

  // Vergleichs-Buttons: ohne Seitenwechsel in den Korb + Drawer öffnen.
  function initAdd(root) {
    if (root.dataset.rdVarAdd === '1') return;
    root.dataset.rdVarAdd = '1';
    root.addEventListener('submit', function (e) {
      var form = e.target.closest('.rd-var__form');
      if (!form) return;
      var btn = form.querySelector('button[name="add"]');
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;
      e.preventDefault();
      if (btn && btn.getAttribute('aria-busy') === 'true') return;
      if (btn) btn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
      })
        .then(function (r) { return r.ok; })
        .then(function (ok) {
          if (ok) {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
          }
        })
        .catch(function () {})
        .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
    });
  }

  function boot() {
    document.querySelectorAll('.rd-var').forEach(function (r) { initFaq(r); initAdd(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
